export default "__VITE_ASSET__CwFYfH16__"